import React, { useContext } from 'react';
import { MarkupContext } from '../../contexts';
import RegionSettings from './regionSettings';

const TabsAndRegions = () => {
  const { tab, setTab } = useContext(MarkupContext);
  const handleChangeTab = (event) => {
    setTab(parseInt(event.target.value));
  };

  return (
    <div className="summary-markup_settings">
      <div className="page-row">
        <div className="page-row_col -none summary-markup_settings_fixed-col">
          <div className="form-label" />
          <div className="button-group">
            <input
              type="radio"
              name="activeTab"
              id="tab1"
              value="0"
              checked={ tab === 0 }
              onChange={ handleChangeTab }
            />
            <label htmlFor="tab1">Reactions and Comments</label>
            <input
              type="radio"
              name="activeTab"
              id="tab2"
              value="1"
              checked={ tab === 1 }
              onChange={ handleChangeTab }
            />
            <label htmlFor="tab2">Heatmap</label>
          </div>
        </div>
        <div className="page-row_col">
          { !tab && <RegionSettings /> }
        </div>
      </div>
    </div>
  );
};

export default TabsAndRegions;
